const initialState = {
    remove: [],
  };
  
  const AHospitalReducers = (state = initialState, action: any) => {
    switch (action.type) {
      case 'fetch_Remove_success':
        return { ...state, remove: action.payload };
  
      default:
        return state;
    }
  };
  
  export default AHospitalReducers;
  
  